if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = null;
      cartUpdateUnsubscriber = null;

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        // ✅ Prevent duplicate listeners
        if (!this.onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            this.handleOptionValueChange.bind(this)
          );
        }

        this.initQuantityHandlers();
      }

      disconnectedCallback() {
        if (this.onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber();
          this.onVariantChangeUnsubscriber = null;
        }

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
          this.cartUpdateUnsubscriber = null;
        }
      }

      // ✅ INSTANT VARIANT SWITCH (NO FETCH)
      handleOptionValueChange({ data: { event, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        const variant = this.getVariantFromOptions(selectedOptionValues);

        if (!variant) {
          this.setUnavailable();
          return;
        }

        this.updateVariantInstantly(variant);
      }

      // ✅ Get variant from JSON (no server call)
      getVariantFromOptions(selectedOptions) {
        const jsonEl = this.querySelector('[type="application/json"]');
        if (!jsonEl) return null;

        const variants = JSON.parse(jsonEl.textContent);

        // selectedOptions contains option value GIDs, not text values.
        // Read actual selected text values directly from the DOM inputs instead.
        const variantSelects = this.querySelector('variant-selects');
        const selectedTexts = [];

        if (variantSelects) {
          // Radio/swatch style pickers
          variantSelects.querySelectorAll('fieldset').forEach(fieldset => {
            const checked = fieldset.querySelector('input[type="radio"]:checked');
            if (checked) selectedTexts.push(checked.value);
          });
          // Dropdown style pickers
          variantSelects.querySelectorAll('select').forEach(select => {
            if (select.value) selectedTexts.push(select.value);
          });
        }

        const optionsToMatch = selectedTexts.length > 0 ? selectedTexts : selectedOptions;

        return variants.find((variant) => {
          return variant.options.every((option, index) => {
            return optionsToMatch[index] === option;
          });
        });
      }

      // ✅ Instant UI update
      updateVariantInstantly(variant) {
        // URL update
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${variant.id}`);

        // Update hidden input
        this.updateVariantInputs(variant.id);

        // Update image
        if (variant.featured_media) {
          const mediaId = `${this.dataset.section}-${variant.featured_media.id}`;
          this.querySelector('media-gallery')?.setActiveMedia(mediaId, true);
        }

        // Update price (basic)
        const priceEl = this.querySelector('[id^="price-"]');
        if (priceEl && variant.price) {
          priceEl.innerHTML = Shopify.formatMoney(variant.price, window.money_format);
        }

        // Enable add to cart
        this.productForm?.toggleSubmitButton(false);

        // Trigger Shopify events (important for compatibility)
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            variant,
          },
        });
      }

      updateVariantInputs(id) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          input.value = id || '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, 'Unavailable');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      fetchQuantityRules() {
        const id = this.productForm?.variantIdInput?.value;
        if (!id) return;

        fetch(`${this.dataset.url}?variant=${id}&section_id=${this.dataset.section}`)
          .then((r) => r.text())
          .catch(console.error);
      }

      get productForm() {
        return this.querySelector('product-form');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}